export default __webpack_public_path__ + "static/media/icon.e38c3510.png";